import React from 'react';
import {useMenu} from '../../../../../hooks/useMenu';
import ProgressBarView from '../../../../views/progressbarView';
import NoFlowInstallationFinished from './installation-finished';

function InstallationNoFlowPB() {
  const {onComponent} = useMenu();
  return (
    <ProgressBarView
      title="Installation Verification"
      content="Verifying Installation"
      onExit={() => onComponent(<NoFlowInstallationFinished />)}
    />
  );
}

export default InstallationNoFlowPB;
